/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const StaffDashboardPeriod = {
    Day: 'Day',
    Week: 'Week',
    Month: 'Month'
};
export function StaffDashboardPeriodFromJSON(json) {
    return StaffDashboardPeriodFromJSONTyped(json, false);
}
export function StaffDashboardPeriodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function StaffDashboardPeriodToJSON(value) {
    return value;
}
